<div class="box">
    <mat-select style="color: white;margin-right: 15px;"
                [disabled]="mode==='edit'"
                [(value)]="selectedTaskTypeLabel">
        <mat-option [value]="item.type"
                    (click)="setType(item.type);"
                    *ngFor="let item of buttons">
            {{item.name}}
        </mat-option>
    </mat-select>
</div>
